import { render, staticRenderFns } from "./Teachers.vue?vue&type=template&id=5998ef3d&scoped=true&"
import script from "./Teachers.vue?vue&type=script&lang=js&"
export * from "./Teachers.vue?vue&type=script&lang=js&"
import style0 from "./Teachers.vue?vue&type=style&index=0&id=5998ef3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5998ef3d",
  null
  
)

export default component.exports